(function(){
  document.querySelector('.share-buttons--link').addEventListener('click', function(e){
    e.preventDefault();
    var el = document.createElement('textarea');
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    var parent = this.parentElement;
    var msg = document.createElement('div');
    msg.classList.add('copy-link-msg');
    msg.innerText = "URL copied to clipboard";
    this.appendChild(msg);
    setTimeout(function(e){
      fadeOut(msg);
    }, 1000)
    function fadeOut(el){
      var parent = el.parentElement;
      var opacity = window.getComputedStyle(el).getPropertyValue("opacity");
      var handle = setInterval(function(e){
        opacity -= 0.05;
        el.style.opacity = opacity;
        if (opacity <= 0){
          clearInterval(handle);
          parent.removeChild(el); 
        }
      },20);
    }
  });
})()